export default __webpack_public_path__ + "static/media/signature.ab1c9e00.svg";